// src/areaAssociados/GaleriaReformas.js
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import { FaImage, FaTimes } from 'react-icons/fa';
import api from '../services/api';

const CATEGORIAS = {
  reforma: { label: 'Reforma', color: '#1565c0', bg: '#e3f2fd' },
  melhoria: { label: 'Melhoria', color: '#2e7d32', bg: '#e8f5e9' },
  manutencao: { label: 'Manutenção', color: '#e65100', bg: '#fff3e0' },
  geral: { label: 'Geral', color: '#616161', bg: '#f5f5f5' }
};

const getCategoria = (cat) => CATEGORIAS[cat] || CATEGORIAS.geral;

const GaleriaReformasAssociado = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);
  const [currentIdx, setCurrentIdx] = useState(0);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  useEffect(() => {
    loadItems();
  }, []);

  const loadItems = async () => {
    try {
      const res = await api.get('/reformas');
      setItems(res.data.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const openModal = (item, idx) => {
    setSelected(item);
    setCurrentIdx(idx);
  };

  const closeModal = () => setSelected(null);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    const diff = touchStartX.current - touchEndX.current;
    const minSwipe = 50;

    if (Math.abs(diff) > minSwipe) {
      if (diff > 0 && currentIdx < items.length - 1) {
        const newIdx = currentIdx + 1;
        setCurrentIdx(newIdx);
        setSelected(items[newIdx]);
      } else if (diff < 0 && currentIdx > 0) {
        const newIdx = currentIdx - 1;
        setCurrentIdx(newIdx);
        setSelected(items[newIdx]);
      }
    }
  };

  if (loading) {
    return (
      <Layout title="Galeria de Reformas" showBackButton onBack={() => navigate('/member/dashboard')}>
        <div style={styles.container}>
          <div style={styles.loading}>Carregando...</div>
        </div>
      </Layout>
    );
  }

  if (items.length === 0) {
    return (
      <Layout title="Galeria de Reformas" showBackButton onBack={() => navigate('/member/dashboard')}>
        <div style={styles.container}>
          <div style={styles.vazio}>
            <FaImage size={48} color="#ccc" />
            <p>Nenhum projeto por enquanto</p>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout title="Galeria de Reformas" showBackButton onBack={() => navigate('/member/dashboard')}>
      <div style={styles.container}>
        <div style={styles.header}>
          <h1 style={styles.titulo}>Projetos Realizados</h1>
          <p style={styles.subtitulo}>Acompanhe as melhorias e reformas do clube</p>
        </div>

        <div style={styles.lista}>
          {items.map((item, idx) => (
            <div key={item._id} style={{ ...styles.card, border: `2px solid ${getCategoria(item.categoria).color}` }} onClick={() => openModal(item, idx)}>
              <div style={styles.cardImages}>
                {item.imagemAntes && (
                  <div style={styles.cardImageWrap}>
                    <img src={item.imagemAntes} alt="Antes" style={styles.cardImg} />
                    <span style={{ ...styles.label, ...styles.labelAntes }}>ANTES</span>
                  </div>
                )}
                {item.imagemDepois && (
                  <div style={styles.cardImageWrap}>
                    <img src={item.imagemDepois} alt="Depois" style={styles.cardImg} />
                    <span style={{ ...styles.label, ...styles.labelDepois }}>DEPOIS</span>
                  </div>
                )}
                {!item.imagemAntes && !item.imagemDepois && (
                  <div style={styles.cardPlaceholder}>
                    <FaImage size={30} color="#ccc" />
                  </div>
                )}
              </div>
              <div style={styles.cardBody}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                  <span style={{ ...styles.catBadge, backgroundColor: getCategoria(item.categoria).bg, color: getCategoria(item.categoria).color, border: `1px solid ${getCategoria(item.categoria).color}` }}>
                    {getCategoria(item.categoria).label}
                  </span>
                </div>
                <h3 style={styles.cardTitulo}>{item.titulo}</h3>
                {item.subtitulo && <p style={styles.cardSubtitulo}>{item.subtitulo}</p>}
              </div>
            </div>
          ))}
        </div>
      </div>

      {selected && (
        <div
          style={styles.modalOverlay}
          onClick={closeModal}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          <div style={styles.modalContent} onClick={e => e.stopPropagation()}>
            <button style={styles.fecharBtn} onClick={closeModal}>
              <FaTimes />
            </button>

            <div style={styles.modalImages}>
              {selected.imagemAntes && (
                <div style={styles.modalImageWrap}>
                  <span style={{ ...styles.label, ...styles.labelAntesStatic }}>ANTES</span>
                  <img src={selected.imagemAntes} alt="Antes" style={styles.modalImg} />
                </div>
              )}
              {selected.imagemDepois && (
                <div style={styles.modalImageWrap}>
                  <span style={{ ...styles.label, ...styles.labelDepoisStatic }}>DEPOIS</span>
                  <img src={selected.imagemDepois} alt="Depois" style={styles.modalImg} />
                </div>
              )}
            </div>

            <div style={styles.modalBody}>
              <h2 style={styles.modalTitulo}>{selected.titulo}</h2>
              {selected.subtitulo && <p style={styles.modalSubtitulo}>{selected.subtitulo}</p>}
              {selected.descricao && <p style={styles.modalDescricao}>{selected.descricao}</p>}
            </div>

            {items.length > 1 && (
              <div style={styles.indicator}>
                {items.map((_, idx) => (
                  <span
                    key={idx}
                    style={{
                      ...styles.dot,
                      ...(idx === currentIdx ? styles.dotActive : {})
                    }}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </Layout>
  );
};

const styles = {
  container: { padding: '20px', maxWidth: '600px', margin: '0 auto' },
  loading: { textAlign: 'center', padding: '60px', color: '#666', fontFamily: 'Montserrat, sans-serif' },
  vazio: { textAlign: 'center', padding: '60px 20px', color: '#999', fontFamily: 'Montserrat, sans-serif' },
  header: { marginBottom: '20px' },
  titulo: { fontSize: '22px', fontWeight: '700', color: '#1A3B7D', marginBottom: '6px', fontFamily: 'Montserrat, sans-serif' },
  subtitulo: { fontSize: '14px', color: '#666', fontFamily: 'Montserrat, sans-serif', margin: 0 },
  lista: { display: 'flex', flexDirection: 'column', gap: '16px' },
  card: { backgroundColor: 'white', borderRadius: '16px', overflow: 'hidden', boxShadow: '0 2px 12px rgba(0,0,0,0.08)', border: '1px solid #eee', cursor: 'pointer' },
  cardImages: { display: 'flex', gap: '2px', height: '180px' },
  cardImageWrap: { flex: 1, overflow: 'hidden', position: 'relative' },
  cardImg: { width: '100%', height: '100%', objectFit: 'cover', display: 'block' },
  cardPlaceholder: { flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f5f5f5' },
  label: { padding: '3px 10px', borderRadius: '12px', fontSize: '10px', fontWeight: '700', color: '#fff', fontFamily: 'Montserrat, sans-serif', textTransform: 'uppercase' },
  labelAntes: { backgroundColor: '#e53935', position: 'absolute', top: '8px', left: '8px' },
  labelDepois: { backgroundColor: '#2e7d32', position: 'absolute', top: '8px', left: '8px' },
  labelAntesStatic: { backgroundColor: '#e53935', display: 'inline-block', marginBottom: '6px' },
  labelDepoisStatic: { backgroundColor: '#2e7d32', display: 'inline-block', marginBottom: '6px' },
  cardBody: { padding: '16px 20px 20px' },
  catBadge: { display: 'inline-block', padding: '2px 8px', borderRadius: '10px', fontSize: '10px', fontWeight: '600', fontFamily: 'Montserrat, sans-serif' },
  cardTitulo: { fontSize: '16px', fontWeight: '700', color: '#1A3B7D', marginBottom: '4px', fontFamily: 'Montserrat, sans-serif', lineHeight: '1.3' },
  cardSubtitulo: { fontSize: '13px', color: '#666', fontFamily: 'Montserrat, sans-serif', margin: '4px 0 0' },
  modalOverlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '20px' },
  modalContent: { backgroundColor: 'white', borderRadius: '16px', width: '100%', maxWidth: '560px', maxHeight: '90vh', overflow: 'auto', position: 'relative' },
  fecharBtn: { position: 'absolute', top: '12px', right: '12px', background: 'rgba(0,0,0,0.)', border: 'none', width: '36px', height: '36px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', zIndex: 10, color: '#555', fontSize: '16px', transition: 'background 0.2s' },
  modalImages: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', padding: '20px 20px 0' },
  modalImageWrap: { display: 'flex', flexDirection: 'column' },
  modalImg: { width: '100%', borderRadius: '10px', objectFit: 'cover', maxHeight: '280px' },
  modalBody: { padding: '20px' },
  modalTitulo: { fontSize: '20px', fontWeight: '700', color: '#1A3B7D', marginBottom: '6px', fontFamily: 'Montserrat, sans-serif' },
  modalSubtitulo: { fontSize: '14px', color: '#666', fontFamily: 'Montserrat, sans-serif', margin: '4px 0 12px' },
  modalDescricao: { fontSize: '14px', color: '#444', fontFamily: 'Montserrat, sans-serif', lineHeight: '1.6' },
  indicator: { display: 'flex', justifyContent: 'center', gap: '6px', padding: '0 20px 20px' },
  dot: { width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#ddd' },
  dotActive: { backgroundColor: '#1A3B7D', transform: 'scale(1.2)' },
};

export default GaleriaReformasAssociado;
